module.exports = __webpack_public_path__ + "img/cashposto_green.686a7086.svg";